<template>
  <section class="grid-flex column">
    <!-- filters -->
    <div class="flex-1 w100">
      <div class="flex column">
        <div>
          <h2>
            Bom dia, {{ user.name }}
          </h2>
        </div>
        <div class="margin-top-s">
          <p>Transforme seus leads em vendas reais. Monitore, gerencie e maximize seus resultados com a precisão que seu negócio precisa.</p>
        </div>
      </div>
    </div>
    <div class="box flex-1 w100 margin-top-l">
      <div class="box-content">
        <b>Atenção:</b> Participe do nosso programa de afiliados e receba 20% de comissão recorrente por cada cliente indicado. <router-link :to="{ name: 'Affiliate' }">Clique aqui para saber mais!</router-link>
      </div>
    </div>
    <section class="flex w100 column margin-top-l">
      <h3>Resultados dos Últimos 30 dias</h3>
      <div class="flex flex-1 w100 margin-top-l">
        <div class="box flex-1 w100">
          <div class="box-content flex column middle center">
            <h4 class="h-title">Vendas</h4>
            <div class="margin-top-s">
              <h4>
                <AnimatedNumber
                  :value="report.sales"
                  :formatValue="$filters.money"
                  :duration="2000"
                  :round="true"
                  :delay="0"
                  easing="easeOutQuart"
                />
              </h4>
            </div>
          </div>
        </div>
        <div class="box flex-1 w100">
          <div class="box-content flex column middle center">
            <h4 class="h-title">Leads</h4>
            <div class="margin-top-s">
              <h4>
                <AnimatedNumber
                  :value="report.leads"
                  :formatValue="$filters.number"
                  :duration="2000"
                  :round="true"
                  :delay="0"
                  easing="easeOutQuart"
                />
              </h4>
            </div>
          </div>
        </div>
        <div class="box flex-1 w100">
          <div class="box-content flex column middle  center">
            <h4 class="h-title">Conversas no WhatsApp</h4>
            <div class="margin-top-s">
              <h4>
                <AnimatedNumber
                :value="report.conversation"
                :formatValue="formatToNumber"
                :duration="2000"
                :round="true"
                :delay="0"
                easing="easeOutQuart"
              />
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="margin-top-l w100">
      <h3>Links rápidos</h3>
      <div class="flex flex-1 w100 margin-top-l middle">
        <div class="box flex-1 w100">
          <div class="">
            <router-link v-if="checkResource('campaigndash')" :to="{ name: 'CampaignDash', params: {slug: 'campaign'} }">
              <div class="button primary w100">Campanhas</div>
            </router-link>
          </div>
        </div>
        <div class="box flex-1 w100">
          <div class="">
            <router-link v-if="checkResource('profit')" :to="{ name: 'Source', params: {slug: 'sale'} }">
              <div class="button primary w100">Origem das Vendas</div>
            </router-link>
          </div>
        </div>  
        <div class="box flex-1 w100">
          <div class="">
            <router-link v-if="checkResource('profit')" :to="{ name: 'Dash', params: {slug: 'first'} }">
              <div class="button primary w100">Dashboards</div>
            </router-link>
          </div>
        </div>  
        <div class="box flex-1 w100">
          <div class="">
            <router-link v-if="checkResource('profit')" :to="{ name: 'Jorney', params: {slug: 'sale'} }">
              <div class="button primary w100">Jornada do Cliente</div>
            </router-link>
          </div>
        </div>  
        <div class="box flex-1 w100">
          <div class="">
              <router-link v-if="checkResource('config')" :to="{ name: 'Config', params: {slug: 'integracoes'} }" >
                <div class="button primary w100">Integrações</div>
              </router-link>
          </div>
        </div>  
      </div>
    </section>
    <div v-if="false" class="flex">
      <section class="flex-1 margin-top-l">
        <div class="flex column">
          <h3>Embaixadores</h3>
          <p>Quer ser embaixador? <a href="https://w.lh4.me/yyorpg" target="_blank">Clique Aqui</a></p>
        </div>
        <div class="box flex-1 w100 margin-top-m">
          <div class="box-content">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum cupiditate, voluptatum, facere officia cum quo provident repellat rem ipsum voluptatibus nostrum itaque assumenda pariatur. Iure quae hic ipsam enim officiis.
          </div>
        </div>
      </section>
      <section class="flex-1 margin-top-l" style="margin-left: 8px;">
        <div class="flex column">
          <h3>Parceiros</h3>
          <p>Quer ser um parceiro? <a href="https://w.lh4.me/yyorpg" target="_blank">Clique Aqui</a></p>
        </div>
        <div class="box flex-1 w100 margin-top-m">
          <div class="box-content">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod culpa quam vitae numquam suscipit accusamus ipsam, dolores eos alias maiores expedita officiis esse minima eum reprehenderit similique aut harum consequuntur.
          </div>
        </div>
      </section>
    </div>
    <section class="margin-top-l flex column w100">
      <h3>Aprenda Algo (Vídeos no Youtube)</h3>
      <div class="box flex-1 w100 margin-top-l">
        <div class="box-content youtube-slides flex">
          <div v-for="(yt, key) in videos" :key="key" class="flex-1 box-yt">
            <iframe
                width="100%"
                height="300px"
                :src="'https://www.youtube.com/embed/' + yt.youtube"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
          </div>
        </div>
      </div>
    </section>

  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";
import {
  getReportHome,
} from "@/services/homev2";

export default {
  name: "homev2",
  components: {
  },
  data() {
    return {
      loading: false,
      report: {
        sales: null,
        leads: null,
        conversation: null
      },
      videos: [
        {
          youtube: "K6MXfZCl5eo",
        },
        {
          youtube: "mFHwTyhGZYc",
        },
      ],
    };
  },
  mounted() {
    this.getReportHome()
  },
  watch: {
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
    checkResource(name) {
      return (
        this.account &&
        this.account.resources &&
        this.account.resources.includes(name)
      );
    },
    getReportHome() {
      this.loading = true
      getReportHome()
        .then(result => {
          this.report = result.report
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
};

</script>

<style lang="scss" scoped>

.box + .box {
  margin-left: 8px !important;
}

.name {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  padding-right: 16px;
}

.h-title{
  color: var(--primary)
}

.youtube-slides {
  overflow-x: scroll;
  width: 100%;
  padding-right: 30px;
  .box-yt {
    margin-left: 8px;
    max-width:300px;
    min-width: 300px;
    max-height:300px;
    min-height: 300px;
    iframe {
      border-radius: 8px;
    }
  }
}

</style>
